// Beyond Personal Matrix - Tests Data (6 tests avec MBTI)

// Icônes personnalisées pour les tests
export const TestIcons = {
  disc: '/picto-disc.png',
  bigfive: '/picto-bigfive.png',
  via: '/picto-via.png',
  schwartz: null, // Garde le SVG actuel
  enneagram: '/picto-enneagram.png',
  mbti: '/picto-mbti.png',
};

// Icônes blanches pour les blocs orange (header du questionnaire)
export const TestIconsWhite = {
  disc: '/picto-disc.png',
  bigfive: '/picto-bigfive.png',
  via: '/picto-via-white.png',
  schwartz: null,
  enneagram: '/picto-enneagram-white.png',
  mbti: '/picto-mbti.png',
};

// SVG pour Schwartz (conservé)
export const SchwartzIcon = (
  <svg viewBox="0 0 64 64" className="w-full h-full">
    <circle cx="32" cy="32" r="26" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.3"/>
    <path d="M32 8 A24 24 0 0 1 56 32" fill="none" stroke="#EF4444" strokeWidth="4" strokeLinecap="round"/>
    <path d="M56 32 A24 24 0 0 1 32 56" fill="none" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round"/>
    <path d="M32 56 A24 24 0 0 1 8 32" fill="none" stroke="#22C55E" strokeWidth="4" strokeLinecap="round"/>
    <path d="M8 32 A24 24 0 0 1 32 8" fill="none" stroke="#3B82F6" strokeWidth="4" strokeLinecap="round"/>
    <circle cx="32" cy="32" r="10" fill="currentColor" opacity="0.2"/>
    <path d="M28 32 L30 34 L36 28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// SVG blanc pour Schwartz (pour blocs orange)
export const SchwartzIconWhite = (
  <svg viewBox="0 0 64 64" className="w-full h-full">
    <circle cx="32" cy="32" r="26" fill="none" stroke="white" strokeWidth="2" opacity="0.5"/>
    <path d="M32 8 A24 24 0 0 1 56 32" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" opacity="0.9"/>
    <path d="M56 32 A24 24 0 0 1 32 56" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" opacity="0.7"/>
    <path d="M32 56 A24 24 0 0 1 8 32" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" opacity="0.8"/>
    <path d="M8 32 A24 24 0 0 1 32 8" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" opacity="0.6"/>
    <circle cx="32" cy="32" r="10" fill="white" opacity="0.2"/>
    <path d="M28 32 L30 34 L36 28" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Beyond Personal Matrix - 6 tests complets
export const ALL_TESTS = [
  { 
    id: 'disc', 
    name: 'DISC', 
    description: 'Votre style de communication',
    icon: 'disc',
    duration: '15 min', 
    questions: 70,
    fullDescription: "Découvrez votre profil comportemental DISC (Dominance, Influence, Stabilité, Conformité) pour optimiser vos échanges professionnels.",
    value: "Essentiel pour comprendre votre style relationnel.",
    availableInDiscovery: true  // Disponible dans l'offre Découverte
  },
  { 
    id: 'bigfive', 
    name: 'Big Five', 
    description: 'Les 5 dimensions de votre personnalité',
    icon: 'bigfive',
    duration: '12 min', 
    questions: 50,
    fullDescription: "Le modèle scientifique de référence mondiale. Mesurez votre Ouverture, Conscienciosité, Extraversion, Agréabilité et Stabilité émotionnelle.",
    value: "Révèle vos traits profonds.",
    availableInDiscovery: true
  },
  { 
    id: 'enneagram', 
    name: 'Ennéagramme', 
    description: 'Vos motivations profondes',
    icon: 'enneagram',
    duration: '10 min', 
    questions: 36,
    fullDescription: "Découvrez votre type parmi les 9 profils de l'Ennéagramme. Comprenez vos motivations inconscientes et vos réactions automatiques.",
    value: "Transforme vos interactions.",
    availableInDiscovery: true
  },
  { 
    id: 'via', 
    name: 'VIA Strengths', 
    description: 'Vos forces signature',
    icon: 'via',
    duration: '20 min', 
    questions: 120,
    fullDescription: "Identifiez vos forces de caractère dominantes parmi 24 forces universelles (leadership, créativité, persévérance, intégrité...).",
    value: "Met en lumière ce que vous apportez naturellement.",
    availableInDiscovery: true
  },
  { 
    id: 'schwartz', 
    name: 'Valeurs Schwartz', 
    description: 'Ce qui guide vos décisions',
    icon: 'schwartz',
    duration: '10 min', 
    questions: 42,
    fullDescription: "Révélez vos valeurs prioritaires parmi les 10 valeurs universelles de Schwartz (réussite, autonomie, sécurité, bienveillance...).",
    value: "Clé pour des partenariats durables.",
    availableInDiscovery: true
  },
  { 
    id: 'mbti', 
    name: 'MBTI', 
    description: 'Votre type parmi 16 profils',
    icon: 'mbti',
    duration: '10 min', 
    questions: 32,
    fullDescription: "Identifiez votre type de personnalité parmi 16 combinaisons (INTJ, ENFP, ESTJ...). Comprenez comment vous percevez le monde et prenez vos décisions.",
    value: "Optimise la collaboration.",
    availableInDiscovery: false  // NON disponible dans l'offre Découverte
  },
];

export const TEST_NAMES = {
  'disc': 'DISC',
  'bigfive': 'Big Five',
  'via': 'VIA Strengths',
  'schwartz': 'Valeurs Schwartz',
  'enneagram': 'Ennéagramme',
  'mbti': 'MBTI',
};

// Tests disponibles pour l'offre Découverte (sans MBTI)
export const DISCOVERY_AVAILABLE_TESTS = ALL_TESTS.filter(t => t.availableInDiscovery);

// Tous les tests (pour Complète et Duo)
export const FULL_TESTS = ALL_TESTS;

// Test counts per pack
export const PACK_TESTS = {
  decouverte: 2,  // User chooses 2 from 5 (no MBTI)
  complete: 6,    // All 6 tests including MBTI
  duo: 6,         // All 6 tests per person
};
